import { Timestamp } from "firebase/firestore";

export const ymdhms = (dt: Date) => {
  if(!dt) {
    return null
  }
  const jstdt = new Date(dt.toLocaleString());
  const y = jstdt.getFullYear();
  const m = ("00" + (jstdt.getMonth() + 1)).slice(-2);
  const d = ("00" + jstdt.getDate()).slice(-2);
  const h = ("00" + jstdt.getHours()).slice(-2);
  const min = ("00" + jstdt.getMinutes()).slice(-2);
  const s = ("00" + jstdt.getSeconds()).slice(-2);
  return y + m + d + h + min + s;
};

export const ymd = (dt: Date) => {
  if(!dt) {
    return null
  }
  const jstdt = new Date(dt.toLocaleString());
  const y = jstdt.getFullYear();
  const m = ("00" + (jstdt.getMonth() + 1)).slice(-2);
  const d = ("00" + jstdt.getDate()).slice(-2);
  return y + m + d;
};

export const ymdhmsStoreFormat = (dt: Date) => {
  if(!dt) {
    return null
  }
  const jstdt = new Date(dt.toLocaleString());
  const y = jstdt.getFullYear();
  const m = ("00" + (jstdt.getMonth() + 1)).slice(-2);
  const d = ("00" + jstdt.getDate()).slice(-2);
  const h = ("00" + jstdt.getHours()).slice(-2);
  const min = ("00" + jstdt.getMinutes()).slice(-2);
  const s = ("00" + jstdt.getSeconds()).slice(-2);
  return `${y}-${m}-${d} ${h}:${min}:${s}`
};

export const ymdDisplayJp = (dt: Date) => {
  if(!dt) {
    return null
  }
  const jstdt = new Date(dt.toLocaleString());
  const y = jstdt.getFullYear();
  const m = ("00" + (jstdt.getMonth() + 1)).slice(-2);
  const d = ("00" + jstdt.getDate()).slice(-2);
  return y + '年' + m + '月' + d + '日';
};

export const hmDisplay = (dt: Date) => {
  if(!dt) {
    return null
  }
  const jstdt = new Date(dt.toLocaleString());
  const h = ("00" + jstdt.getHours()).slice(-2);
  const min = ("00" + jstdt.getMinutes()).slice(-2);
  return h + ':' + min;
};

export const hmDisplayJp = (dt: Date) => {
  if(!dt) {
    return null
  }
  const jstdt = new Date(dt.toLocaleString());
  const h = ("00" + jstdt.getHours()).slice(-2);
  const min = ("00" + jstdt.getMinutes()).slice(-2);
  return h + '時' + min + '分';
};

export const ymdhmDisplayJp = (dt: Date) => {
  if(!dt) {
    return null
  }
  const jstdt = new Date(dt.toLocaleString());
  const y = jstdt.getFullYear();
  const m = ("00" + (jstdt.getMonth() + 1)).slice(-2);
  const d = ("00" + jstdt.getDate()).slice(-2);
  const h = ("00" + jstdt.getHours()).slice(-2);
  const min = ("00" + jstdt.getMinutes()).slice(-2);
  return y + '年' + m + '月' + d + '日 ' + h + ':' + min;
};

export const getDayOfWeekEn = (date) => {
  if(!date) {
    return null
  }
  return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][date.getDay()]
}

export const getDayOfWeekJa = (date) => {
  if(!date) {
    return null
  }
  return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()]
}

export const toDate = (ts) => {
  if (!ts) {
    return null
  };
  if (Object.prototype.toString.call(ts).includes('Date')) {
    return ts
  }
  if (ts.seconds) {
    return (new Timestamp(ts.seconds, ts.nanoseconds)).toDate()
  }
  if (Object.prototype.toString.call(new Date(ts)).includes('Date')) {
    return new Date(ts)
  }
  return null
}

export const hoursToMinutes = (hours, minutes) => {
  return hours * 60 + minutes
}

export const diffMinutes = (after: Date, before: Date) => {
  if (!after || !before) return 0
  return (new Date((new Date(after)).getTime() - (new Date(before)).getTime())).getMinutes()
}

export const diffSeconds = (after: Date, before: Date) => {
  if (!after || !before) return 0
  return (new Date((new Date(after)).getTime() - (new Date(before)).getTime())).getSeconds()
}


export const setHmsToZero = (date: Date) => {
  if (!date) return
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
}

export const setHmsToMax = (date: Date) => {
  if (!date) return
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  date.setMilliseconds(999);
}

export const getFirstDateOf = (month: number) => {
  if (!month) return
  const now = new Date();
  now.setMonth(month - 1);
  now.setDate(1);
  setHmsToZero(now);
  return now
}

export const getLastDateOf = (month: number) => {
  if (!month) return
  const now = new Date();
  now.setMonth(month);
  now.setDate(0);
  setHmsToMax(now);
  return now
}